/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIOfferSearchResult } from './APIOfferSearchResult';
import {
    APIOfferSearchResultFromJSON,
    APIOfferSearchResultFromJSONTyped,
    APIOfferSearchResultToJSON,
} from './APIOfferSearchResult';
import type { APIPagination } from './APIPagination';
import {
    APIPaginationFromJSON,
    APIPaginationFromJSONTyped,
    APIPaginationToJSON,
} from './APIPagination';

/**
 * 
 * @export
 * @interface APIOfferSearchResponse
 */
export interface APIOfferSearchResponse {
    /**
     * 
     * @type {number}
     * @memberof APIOfferSearchResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof APIOfferSearchResponse
     */
    maxScore: number | null;
    /**
     * 
     * @type {Array<APIOfferSearchResult>}
     * @memberof APIOfferSearchResponse
     */
    results: Array<APIOfferSearchResult>;
    /**
     * 
     * @type {APIPagination}
     * @memberof APIOfferSearchResponse
     */
    page: APIPagination;
}

/**
 * Check if a given object implements the APIOfferSearchResponse interface.
 */
export function instanceOfAPIOfferSearchResponse(value: object): value is APIOfferSearchResponse {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('maxScore' in value) || value['maxScore'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    return true;
}

export function APIOfferSearchResponseFromJSON(json: any): APIOfferSearchResponse {
    return APIOfferSearchResponseFromJSONTyped(json, false);
}

export function APIOfferSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIOfferSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'maxScore': json['max_score'],
        'results': ((json['results'] as Array<any>).map(APIOfferSearchResultFromJSON)),
        'page': APIPaginationFromJSON(json['page']),
    };
}

export function APIOfferSearchResponseToJSON(value?: APIOfferSearchResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'total': value['total'],
        'max_score': value['maxScore'],
        'results': ((value['results'] as Array<any>).map(APIOfferSearchResultToJSON)),
        'page': APIPaginationToJSON(value['page']),
    };
}

